import { Send, AlertTriangle, TrendingUp } from "lucide-react";

export const ColdEmailTakeaway = () => {
  return (
    <div className="bg-gradient-to-r from-primary/10 via-primary/5 to-transparent rounded-2xl p-6 sm:p-8 border border-primary/20">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 rounded-xl bg-primary/20 flex items-center justify-center flex-shrink-0">
          <Send className="w-6 h-6 text-primary" />
        </div>
        <div>
          <h3 className="font-display text-lg font-semibold text-foreground mb-2">
            The Bottom Line
          </h3>
          <p className="text-muted-foreground leading-relaxed">
            <strong className="text-foreground">Cold email isn't dead — but it's harder than ever.</strong> Our data shows that properly warmed domains sending 50-100 personalized emails daily achieve 65%+ open rates. The key is volume control, domain health, and treating cold outreach like a precision tool, not a spray-and-pray cannon.
          </p>
          <div className="flex flex-wrap gap-3 mt-4">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-success/10 text-success text-sm">
              <TrendingUp className="w-3.5 h-3.5" />
              65%+ open rates achievable
            </span>
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-warning/10 text-warning text-sm">
              <AlertTriangle className="w-3.5 h-3.5" />
              Volume is the #1 killer
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
